import {
  emptyStudentAcademicProgramHook,
  IStudentAcademicProgram,
  studentAcademicProgramsReactiveVar,
} from '../../cache/learner/studentAcademicProgramsReactiveVar';

interface IStudentAcademicProgramHook {
  clearAcademicProgramListWizardError: () => void;
  setStudentAcademicProgramsError: (errorMessage: string) => void;
  setStudentAcademicPrograms: (academicProgramList: IStudentAcademicProgram[]) => void;
}

const useStudentAcademicProgramsHook = (): IStudentAcademicProgramHook => {
  const clearAcademicProgramListWizardError = (): void => {
    studentAcademicProgramsReactiveVar(emptyStudentAcademicProgramHook);
  };
  const setStudentAcademicProgramsError = (errorMessage: string): void => {
    studentAcademicProgramsReactiveVar({ ...emptyStudentAcademicProgramHook, error: errorMessage });
  };

  const setStudentAcademicPrograms = (academicProgramList: IStudentAcademicProgram[]): void => {
    studentAcademicProgramsReactiveVar({
      error: '',
      data: academicProgramList,
    });
  };

  return {
    clearAcademicProgramListWizardError,
    setStudentAcademicProgramsError,
    setStudentAcademicPrograms,
  };
};

export default useStudentAcademicProgramsHook;
